import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const ratioEsimRegionEntity: Entity = {
  model: model,
  repository: repository,
}

export default ratioEsimRegionEntity
